import { useEffect, } from 'react'
import { Toast, ToastContainer } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { appNotification, dismissAppNotification, selectAppNotification, selectModalNotifications } from '../../app.slice'
import useBreakpoint from '../../hooks/useBreakpoint'
import './Snackbar.css'
import SweetAlert from './SweetAlert'
import NotificationModal from './NotificationModal'

/** How long the non-modal surfaces (snackbar / toast) stay on screen before clearing themselves. */
const AUTO_DISMISS_MS = 2500

const ToastWrapper = () => {
    const { title, msg, type = 'danger', notificationType } = useSelector(selectAppNotification)
    const modalNotifications = useSelector(selectModalNotifications)
    const { sm } = useBreakpoint()
    const dispatch = useDispatch()

    // Modal notifications stay until the user dismisses them, so both the error and the
    // success message can actually be read. The other surfaces still auto-clear.
    useEffect(() => {
        if (!msg || notificationType === 'modal') return
        const timer = setTimeout(() => dispatch(appNotification({ title: '', msg: undefined })), AUTO_DISMISS_MS)
        return () => clearTimeout(timer)
    }, [msg, notificationType, dispatch])

    const renderTransientSurface = () => {
        if (notificationType === 'modal') return null
        if (sm)
            return !!msg && <div className="snackbar">{msg}</div>
        if (notificationType === 'alert')
            return (
                <ToastContainer
                    className="p-3"
                    position={'top-end'}
                    style={{ zIndex: 1057, position: 'fixed' }}
                >
                    <Toast show={!!msg} style={{ position: 'relative', top: 100 }}>
                        <Toast.Header className={`bg-light-${type}`}>
                            <strong className={`me-auto`}>{title}</strong>
                        </Toast.Header>
                        <Toast.Body className={`bg-light-${type}`}>
                            <span>{msg}</span>
                        </Toast.Body>
                    </Toast>
                </ToastContainer>
            )
        return !!msg && <SweetAlert />
    }

    // The modal renders alongside the transient surfaces rather than instead of them, so a
    // toast arriving mid-burst cannot hide errors the user has not acknowledged yet.
    return (
        <>
            <NotificationModal
                open={modalNotifications.length > 0}
                notifications={modalNotifications}
                onClose={() => dispatch(dismissAppNotification())}
            />
            {renderTransientSurface()}
        </>
    )
}

export default ToastWrapper
